import { Divider } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { LogoutIcon } from '@/shared/assets/icons/logout-icon';
import { UserIcon } from '@/shared/assets/icons/user-icon';
import { MenuItem } from '@/shared/components/ui/menu-item/menu-item';
import { PopoverController } from '@/shared/components/ui/popover/components/popover-controller/popover-controller';
import { DateTimeFormat } from '@/shared/features/header/components/date-time-format/date-time-format';
import { ResetTableViews } from '@/shared/features/header/components/reset-table-views/reset-table-views';
import { TUserMenuProps } from '@/shared/features/header/components/user-menu/user-menu.types';
import { UserMenuButton } from '@/shared/features/header/components/user-menu-button/user-menu-button';
import { LanguageSwitcher } from '@/shared/features/language-switcher/language-switcher';
import { ThemeSwitcher } from '@/shared/features/theme-switcher/components/theme-switcher';
import { logout } from '@/shared/redux/api/auth/auth-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';

export const UserMenu: React.FC<TUserMenuProps> = ({
  hideProfileMenuItem,
  additionalItems,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await dispatch(logout());
  };

  return (
    <PopoverController trigger={<UserMenuButton />} matchTriggerWidth>
      {(popoverClose) => (
        <>
          {!hideProfileMenuItem && (
            <MenuItem
              icon={<UserIcon />}
              onClick={() => {
                navigate('/user-profile');
                popoverClose();
              }}
            >
              {t('common:profile')}
            </MenuItem>
          )}
          <ThemeSwitcher component="MenuItem" />
          <LanguageSwitcher component="MenuItem" />
          <DateTimeFormat handleClose={popoverClose} />
          <ResetTableViews />
          {additionalItems}
          <Divider />
          <MenuItem
            variant="alert"
            icon={<LogoutIcon />}
            onClick={handleLogout}
          >
            {t('ui:logout')}
          </MenuItem>
        </>
      )}
    </PopoverController>
  );
};
